/* eslint-disable @typescript-eslint/naming-convention */
import { Directive, OnDestroy, Self } from '@angular/core';

import { ReportOutputComponent } from '@ndt/report-output/report-output.component';
import { ReportOutputBase } from '@ndt/report-output/shared/models/report-output-base';
import { ReportContainerDirective } from './report-container.directive';

@Directive({
    selector: '[ndtReportOutput]',
    standalone: false
})
export class ReportOutputDirective<R extends ReportOutputBase<any, any>> implements OnDestroy {
   constructor(@Self() component: ReportOutputComponent<R>, private reportContainer: ReportContainerDirective<R>) {
      reportContainer.registerOutputComponent(component);
   }

   ngOnDestroy(): void {
      this.reportContainer.registerOutputComponent(null);
   }
}
